import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { DeductionAfp } from "../entities/deduction-afp";
import { tap } from 'rxjs/operators';

@Injectable()
export class DeductionAfpService extends BaseCrudService<DeductionAfp> {

    public uri = '/api/deductionAfp/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance DeductionAfpService');
    }

    buildSentence(entity?: DeductionAfp, event?: LazyLoadEvent): HttpParams {
        if (entity) {
          let query = '';
          query = query.concat(
            entity.code ?
              `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.maximumAmount ?
              `maximumAmount${QueryOperator.Contain}${entity.maximumAmount}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.percentage1 ?
              `percentage1${QueryOperator.Equal}${entity.percentage1}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.percentage2 ?
              `percentage2${QueryOperator.Contain}${entity.percentage2}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.percentage3 ?
              `percentage3${QueryOperator.Contain}${entity.percentage3}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.percentage4 ?
              `percentage4${QueryOperator.Contain}${entity.percentage4}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          if (entity.month && entity.month.id) {
            query = query.concat(
              `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
            );
          }
          if (entity.afp && entity.afp.id) {
            query = query.concat(
              `afp.id${QueryOperator.Equal}${entity.afp.id}${QueryOperator.Split}`
            );
          }
          if (entity.payrollConcept) {
            query = query.concat(entity.payrollConcept.id ?
              `payrollConcept.id${QueryOperator.Equal}${entity.payrollConcept.id}${QueryOperator.Split}`
              : QueryOperator.Empty
            );
            query = query.concat(entity.payrollConcept && entity.payrollConcept.fiscalYear ?
              `payrollConcept.fiscalYear.id${QueryOperator.Equal}${entity.payrollConcept.fiscalYear.id}${QueryOperator.Split}`
              : QueryOperator.Empty
            );
            query = query.concat(entity.payrollConcept && entity.payrollConcept.executingUnit ?
              `payrollConcept.executingUnit.id${QueryOperator.Equal}${entity.payrollConcept.executingUnit.id}${QueryOperator.Split}`
              : QueryOperator.Empty
            );
          }
             this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }
    
        if (event) {
          const page = ((event.first + event.rows) / event.rows - 1).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
      }

      
      copyDeductionAfp(params: DeductionAfp) {
        const url = `${this.rutaServidor}${this.uri}copyDeductionAfp`;
        this.spinnerService.showAll();
        return this.httpClient.post<DeductionAfp>(url, params)
          .pipe(
            tap(response => {
              this.spinnerService.hideAll();
             //console.log('copyDeductionAfp', response);
            })
          );
        }
}


// WEBPACK FOOTER //
// ./src/app/core/services/deduction-afp.service.ts